module.exports = __webpack_public_path__ + "static/design_background_v2-177aea1a1b0c25ad3420d80d2ed7a0c0.png";